module.exports = __webpack_public_path__ + "media/index/abby_240x240_2x-e4415ba3.png";